import { Link, Outlet, useParams } from 'react-router-dom'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import {useGetResponseByIdQuery, useGetResponsesQuery} from '../responses/responsesApiSlice'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import EditGrade from './EditGrade'
// import ResponseTextView from '../../partial/ResponseTextView'
// import ResponseCodeView from '../../partial/ResponseCodeView'
// import ResponseFileView from '../../partial/ResponseFileView'
// import AdditionListView from '../../partial/AdditionListView'
import ReactQuill from 'react-quill'
import BooleansView from '../../partial/BooleansView'
import getFilePath from "../../utils/getFilePath"
import FriendMenu from './response/FriendMenu'
const GradeItem = () => {
    const {groupId, taskId, responseId} = useParams()
    useTitle('geshtop-Exercise: Grades List')
    // const { response } = useGetResponsesQuery("responsesList", {
    //     selectFromResult: ({ data }) => ({
    //         response: data?.entities[responseId]
    //     }),
    // })
    const {
        data: response,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetResponseByIdQuery({id:responseId})

    //const created = new Date(response.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    //const updated = new Date(response.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
   if(!response) return<div>loading...</div>
    // const action ={}
    // const type = response.action?.type || "Text"
    let content
     content = 
     <>
    
    <EditGrade response={response} />
     <div className='grid-results'>
        <span className='grid-results-header'>#</span>
        <span className='grid-results-data'>{response._id}</span>
        <span className='grid-results-header'>משתמש</span>
        <span className='grid-results-data'>{response.username}</span>
        <span className='grid-results-header'>שם משתמש</span>
        <span className='grid-results-data'>{response.fullname}</span>
        {response.userImage && <><span className='grid-results-header'>תמונה </span>
        <span className='grid-results-data'><div className='profile-image profile-image-large' style={{backgroundImage:`url(${getFilePath(response.userImage)})`}}></div></span></> }
        <span className='grid-results-header'> קבוצה</span>
        <span className='grid-results-data'>{response.group_model?.name} -{response.group_model?.year}</span>
        <span className='grid-results-header'>משימה</span>
        <span className='grid-results-data'>{response.task?.title}</span>
        <span className='grid-results-header'>פירוט משימה</span>
        <span className='grid-results-data quill-max-height-250'>
        <ReactQuill
                     theme='bubble'
                    readOnly
                    value={response.task?.body}
                    
                    ></ReactQuill>

        </span>

       
{/* 
        <span className='grid-results-header'>פירוט משימה</span>
        <span className='grid-results-data'>{action.taskBody}</span> */}
        <span className='grid-results-header'> דרישה</span>
        <span className='grid-results-data'> {response.action?.title} <hr /> {response.action?.text} {response.action?.ratio? `(${response.action.ratio}%)`:""}</span>
        <FriendMenu response={response} relatedResponses = {response.relatedResponses} />
        <Outlet />

        <BooleansView booleans={response.booleans} />
        {(response.friendsObj && response.friendsObj.length> 0) &&<>
        <span className='grid-results-header'> עבדתן יחד?</span>
        <span className='grid-results-data'>{ response.friendsObj.map(friend=>  ` ${friend.name}, `)}</span>
</>}
        <span className='grid-results-header'> בוצע בתאריך</span>
        <span className='grid-results-data'>{response.responseAt}</span>
 
     
    
        <span className='grid-results-header'>ציון </span>
        <span className='grid-results-data'>
        {response?.grade > -1
                    ? <span className="status--completed">{response.grade}</span>
                    : <span className="status--open">לא ניתן ציון</span>
                    } 
            </span>
          
         
        <span className='grid-results-header'> ציון ע"י</span>
        <span className='grid-results-data'>{response.gradeByName}</span>
        <span className='grid-results-header'> ציון בתאריך</span>
        <span className='grid-results-data'>{response.gradeAt}</span>
        <span className='grid-results-header'> הערות בודק </span>
        <span className='grid-results-data'>

        <ReactQuill
                     theme='bubble'
                    readOnly
                    value={response.notes}
                    
                    ></ReactQuill>

        {/* <textarea readOnly
                    className={`form__input  form__input--comments  `}
                    id="comments"
                    name="comments"
                    value={response.notes}
                    
                />         */}
            </span>


     </div>
    
     </>
   
  
            

    return content
}
export default GradeItem